import React, { ChangeEvent, useEffect, useState, useRef } from "react";
import { ImageGalleryProps } from "../../types/interface";
import { Checkbox, CircularProgress, Grid, MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import { useTest } from "./TestContext";
import Performs from "../../assets/icons/vector.svg";
import Slider from "@mui/material/Slider";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProjectTrain,
  clearModelData,
} from "../../store/slice/ProjectTrainSlice";
import { AppDispatch, RootState } from "../../store/store";
import {
  ProjectTrain,
  TestRequestPayload,
} from "../../types/interface/ProjectTrain.interface";
import { addTest } from "../../store/slice/ProjectTestSlice";
import { toast } from "react-toastify";
import { throttle, debounce } from "lodash";

const InferenceOther: React.FC<ImageGalleryProps> = ({ id }) => {
  const {
    compare,
    handleModelChangeOther,
    modelOther,
    sliderValueOther,
    handleSliderChangeOther,
    fileUpload,
    setNextResult,
    handleCheckboxChange,
    model,
    setSliderValueOther,
    setLoadOtherInference,
  } = useTest();
  const dispatch: AppDispatch = useDispatch();
  const [modelsList, setModelsList] = useState<ProjectTrain[]>([]);
    const loadingModel = useSelector((state: RootState) => state.projectTrain.loading);
  const [loading, setLoading] = useState(false);

  const { dataModels, error } = useSelector(
    (state: RootState) => state.projectTrain
  );
  const [otherDisablePerformButton, setOtherDisablePerformButton] =
    useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef<HTMLDivElement | null>(null); // Ref for the slider container

  // Handle mouse down (start dragging)
  const handleMouseDown = (event: React.MouseEvent) => {
    setOtherDisablePerformButton(false);
    setIsDragging(true); // Set dragging state to true
  };

  // Handle mouse move (update slider value while dragging)

  const handleMouseMove = debounce((event: MouseEvent) => {
    if (!isDragging || !sliderRef.current) return;

    const newValue = calculateSliderValueFromMouse(event);
    setSliderValueOther(newValue); // Update slider value in real-time
  }, 100); // Debounce to update after 100ms of no mouse movement

  // Handle onClick on the slider bar (track)
  const handleClickOnTrack = (event: React.MouseEvent) => {
    setOtherDisablePerformButton(false);
    if (!sliderRef.current) return;

    // Access native mouse event properties
    const nativeEvent = event.nativeEvent as MouseEvent; // Cast to native MouseEvent

    // Calculate the new value based on the click position
    const newValue = calculateSliderValueFromMouse(nativeEvent); // Pass the native event
    setSliderValueOther(newValue);
  };

  // Handle mouse up (stop dragging)
  const handleMouseUp = () => {
    setIsDragging(false); // Stop dragging
  };

  // Calculate slider value from mouse position
  const calculateSliderValueFromMouse = (event: MouseEvent): number => {
    if (!sliderRef.current) return 1;

    const sliderRect = sliderRef.current.getBoundingClientRect();
    const sliderLeft = sliderRect.left; // Left position of the slider
    const sliderWidth = sliderRect.width; // Width of the slider

    // Calculate the mouse's position relative to the slider
    const relativeMouseX = Math.min(
      Math.max(event.clientX - sliderLeft, 0),
      sliderWidth
    );

    const minValue = 1;
    const maxValue = 100;

    // Map the mouse position to the slider range
    return Math.round(
      (relativeMouseX / sliderWidth) * (maxValue - minValue) + minValue
    );
  };

  // Set up mouse event listeners (mouse move and mouse up)
  useEffect(() => {
    if (isDragging) {
      // Add mousemove and mouseup events to the window when dragging starts
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      // Clean up events when dragging ends
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  useEffect(() => {
    dispatch(clearModelData());
    dispatch(fetchProjectTrain(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (dataModels.length) {
      setModelsList(dataModels);
    }
    if (error) {
      setModelsList([]);
      toast.error(error, {
        position: "bottom-right",
      });
    }
  }, [dataModels, error]);

  //// select first model //
  useEffect(() => {
    if (modelsList.length > 0) {
      // Automatically select the first model in the list
      handleModelChangeOther(modelsList[0].id);
    }
  }, [modelsList]);

  const handlePerformTest = () => {
    setOtherDisablePerformButton(true);
    if (modelOther && fileUpload) {
      setLoading(true); // Start loader
      setLoadOtherInference(true);
      // Ensure sliderValue is a number
      const projectTitle =   localStorage.getItem("projectTitle");
      const sliderValueNumber = Array.isArray(sliderValueOther)
        ? sliderValueOther[0]
        : sliderValueOther;

      // Construct the payload
      const payload: TestRequestPayload = {
        model: modelOther,
        fileUpload: fileUpload,
        projectTitle: projectTitle ?? ""
      };

      // Dispatch the action with the correct payload
      dispatch(addTest(payload))
        .unwrap()
        .then((result: any) => {
          setNextResult(result);
          setLoading(false); // Stop loader
          setLoadOtherInference(false);
          toast.success("Test completed successfully!");
        })
        .catch((err: any) => {
          toast.error(err, {
            position: "bottom-right",
          });
          setOtherDisablePerformButton(false);
          setLoading(false); // Stop loader
          setLoadOtherInference(false);
        });
    }
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          padding: "4px",
        }}
        /* sx={{ justifyContent: "space-between", paffing: "4px" }} */
      >
        <Grid
          item
          xs={compare ? 4.5 : 12} // Full width on extra small screens
          sm={compare ? 4.5 : 6} // Half width on small screens
          md={compare ? 4.5 : 3} // Quarter width on medium screens
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            order: 1, // Order for the list of models
          }}
        >
          {!loadingModel && modelsList.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", order: 2 }}>
              <span style={{ marginBottom: "1px", fontSize: "13px" }}>
                Select Model
              </span>
              {""}
              <Select
                value={modelOther}
                onChange={(e) => {
                  handleModelChangeOther(e.target.value);
                  setOtherDisablePerformButton(false);
                }} // Ensure correct value is passed
                displayEmpty
                fullWidth
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  border: "none", // Remove default border
                  backgroundColor: "rgb(210, 233, 251)",
                  padding: "8px 12px", // Add vertical padding
                  height: "30px",
                  color: "#111", // Set text color
                  maxWidth: "auto",
                  marginTop: "10px",
                  "& .MuiSelect-select": {
                    padding: "8px 12px", // Ensure select padding is consistent
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select a model
                </MenuItem>
                {modelsList && modelsList.length > 0 ? (
                  modelsList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No models available</MenuItem>
                )}
              </Select>
            </div>
          ) :  loadingModel ? ( 
            <h4>Loading Models...</h4>  
        ) : ( 
            <h4>No Models Available</h4>  
        )}
        </Grid>

        {modelOther ? (
          <>            
            <Grid
              item
              xs={compare ? 4.5 : 12} // Full width on extra small screens
              sm={compare ? 4.5 : 6} // Half width on small screens
              md={compare ? 4.5 : 3} // Quarter width on medium screens
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "end",
                order: compare ? 2 : 3,
              }}
            >
              <button
                style={{
                  marginLeft: "20px",
                  background:
                    loading || otherDisablePerformButton ? "gray" : "#1D97F3", // Change color if loading
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: "200px",
                  justifyContent: "center",
                  color: "#fff",
                  padding: "5px",
                  border: "none",
                  textAlign: "center",
                  cursor: otherDisablePerformButton ? "not-allowed" : "pointer",
                }}
                onClick={handlePerformTest}
                disabled={loading || otherDisablePerformButton} // Disable the button while loading
              >
                <img
                  src={Performs}
                  alt="Performs"
                  style={{ marginRight: "5px" }}
                />
                Perform Test
              </button>
            </Grid>
          </>
        ) : (
          ""
        )}
        <Grid
          item
          xs={compare ? 3 : 12} // Full width on extra small screens
          sm={compare ? 3 : 6} // Half width on small screens
          md={compare ? 3 : 1} // Quarter width on medium screens
          style={{
            display: "flex",
            alignItems: "flex-end", // Align items at the bottom vertically
            justifyContent: "flex-start", // Align items at the start horizontally
            order: compare ? 3 : 4,
            /* overflow: "hidden",
            paddingLeft: compare ? 0 : "", */
          }}
        >
          <div
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() =>
              handleCheckboxChange({
                target: { checked: !compare },
              } as ChangeEvent<HTMLInputElement>)
            }
          >
            <Checkbox checked={compare} />
            Compare
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default InferenceOther;
